import React, { useContext } from 'react';
import { FormDataContext } from './contexts/FormContext';
import { Card, CardContent } from '@mui/material';

const defaultProps = {
    sectionId: '',
    renderSectionHeader: () => {}
};

const AttachmentMatrix = (rawProps) => {
    const props = {...defaultProps, ...rawProps};

    const formDataContext = useContext(FormDataContext);

    return (
        <>
            <Card sx={{ mb: 2 }}>
                <CardContent sx={{ p: 2 }}>
                    {props.renderSectionHeader("Attachments Matrix")}
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead className="bg-primary text-white">
                                <tr>
                                    <th className="text-center">#</th>
                                    <th>Part / Element</th>
                                    <th>Category / Sub-Category</th>
                                    <th>Label</th>
                                    <th>File Name</th>
                                    <th>User Name</th>
                                    <th className="text-center">Date/Time</th>
                                    {formDataContext.isReadOnly === false && <th>Actions</th>}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="text-center" colSpan={8}>
                                        No Data Found
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CardContent>
            </Card>
        </>
    );
}

export default AttachmentMatrix;
